module.exports = __webpack_public_path__ + "static/joystream-dao-foreground-168eac5390827ca2b6892e02b1bda895.png";